import { useEditorContext } from 'contexts';

const useEditor = useEditorContext;
export default useEditor;
